import { Injectable } from '@angular/core';
import { ApiService, PagedRecords } from '../../shared/api.service';

@Injectable()
export class JobsService {
	serviceName = 'scheduler-common/';
	constructor(private apiService: ApiService) { }

	get(filter: Object, page: number = 1, size: number = 10, query: string): Promise<any> {
		const url = `${this.serviceName}${query}`;
		return this.apiService.getWithFilter(url, filter, page, size)
			.then(response => response as any);
	}

	create(data: Object, query: string): Promise<Object> {
		const url = `${this.serviceName}${query}`;
		return this.apiService.post(url, data);
	}

	update(data: Object, query: string): Promise<Object> {
		const url = `${this.serviceName}${query}`;
		return this.apiService.post(url, data);
	}
	put(data: Object, query: string): Promise<Object> {
		const url = `${this.serviceName}${query}`;
		return this.apiService.post(url, data);
	}

}

